module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-06.054f5c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-06.jpg
// module id = Ckc9
// module chunks = 1